// HideScrollbar.js

const hideScrollbar = () => {
  // Firefox
  document.documentElement.style.scrollbarWidth = 'none';
  document.body.style.scrollbarWidth = 'none';

  // Chrome, Safari, Edge
  document.documentElement.style.overflow = 'scroll'; // allow scroll
  document.documentElement.style.setProperty('--scrollbar-display', 'none');
};

export default hideScrollbar;
